import { render, staticRenderFns } from "./BuyItAgainCarousel.vue?vue&type=template&id=0019c65a&scoped=true"
import script from "./BuyItAgainCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyItAgainCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyItAgainCarousel.vue?vue&type=style&index=0&id=0019c65a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019c65a",
  null
  
)

export default component.exports